<template lang="pug">
  div.stamp(:style="`padding: ${stampPadding}`" :class="[success ? 'border-success' : 'border-normal']")
    v-icon(size="16" :color="success ? 'success500' : '#848484'") $yzi-gift-02
</template>

<script>
export default {
  props: {
    paddingTop: {
      type: String,
      default: '1px'
    },
    paddingBottom: {
      type: String,
      default: '1px'
    },
    paddingLeft: {
      type: String,
      default: '7px'
    },
    paddingRight: {
      type: String,
      default: '7px'
    },
    success: {
      type: Boolean,
    }
  },
  computed: {
    stampPadding () {
      return `${this.paddingTop} ${this.paddingRight} ${this.paddingBottom} ${this.paddingLeft}`
    }
  },
}
</script>

<style scoped>
.stamp {
  width: 35px;
  height: 35px;
  border-radius: 50% !important;
}
.border-normal {
  border: 2px #848484 dashed;
}
.border-success {
  border: 2px #259143 solid;
}
</style>